import { IconButton } from '@mui/material';
import { Search } from '@mui/icons-material';
import camelcaseKeys from 'camelcase-keys';
import { UseFormGetValues, UseFormReset } from 'react-hook-form';

import { getPatient } from '../PatientList/api';
import useNotification from 'hooks/useNotification';

interface Props {
  reset: UseFormReset<any>;
  getValues: UseFormGetValues<any>;
  setIsSearched: (value: boolean) => void;
}

const SearchPatientId = ({ reset, getValues, setIsSearched }: Props) => {
  const { onSuccess, onFail, onResultCode, onRequired } = useNotification();

  const onSearch = () => {
    const patientId = getValues('patient.patientId');
    if (!patientId) return onRequired('REQUIRED.PATIENT.ID');

    getPatient({ patientId })
      .then(({ data: { rc, ...values } }) => {
        if (rc !== 1) return onResultCode(rc);

        let defaultValue = {} as any;
        for (const key in values) {
          defaultValue[key] = camelcaseKeys(values[key]);
        }

        reset(defaultValue);
        onSuccess('가상환자 조회에 성공하였습니다.');
        setIsSearched(true);
      })
      .catch(e => onFail('가상환자 조회에 실패하였습니다', e));
  };

  return (
    <IconButton size="small" onClick={onSearch}>
      <Search sx={{ fontSize: 16 }} />
    </IconButton>
  );
};

export default SearchPatientId;
